import React, {useEffect, useLayoutEffect, useState} from 'react';
import {SafeAreaView, View, Image, ActivityIndicator} from 'react-native';

import sy from '~/styles';
import {
  dealer as dealerApi,
  service_request as serviceRequestApi,
} from '~/api/public';
import {apiRoot as publicApiRoot} from '~/api/public/endpoints';
import {DefaultButton, Text} from '~/components/controls';
import {PublicContentView} from '~/components/shared';
import {useDispatch} from '~/lib/hooks';
import {STATUS_CODES} from '~/types/statuses';

const Intro = ({navigation, route}) => {
  const dispatch = useDispatch();
  const request_id = route.params?.request_id;
  const [dealer, setDealer] = useState(null);
  const [loading, setLoading] = useState(true);
  const [imageWidth, setImageWidth] = useState(null);

  useLayoutEffect(() => {
    navigation.setOptions({
      headerShown: false,
    });
  }, [navigation]);

  useEffect(() => {
    const fetch = async () => {
      let dealer = null;
      let request = null;
      if (request_id) {
        try {
          request = await serviceRequestApi.details(request_id);
          dealer = await dealerApi.details(request.dealer_id);
        } catch {
          dealer = null;
          request = null;
        }
      }

      if (!dealer || !request) {
        navigation?.replace('Error');
        return;
      }

      if (request?.status !== STATUS_CODES.ApprovalRequested) {
        navigation.replace('Overview', {screen: 'Chat', params: {request_id}});
      }

      setDealer(dealer);
      setLoading(false);
    };

    fetch();
  }, [navigation, request_id, dispatch]);

  const onPhotoLayout = (e) => {
    const {layout} = e.nativeEvent;
    setImageWidth(layout.width);
  };

  const imageHeight = imageWidth ? imageWidth * (186.56 / 414) : null;

  return (
    <SafeAreaView style={sy.mainView}>
      <PublicContentView>
        <>
          {loading ? (
            <View style={[sy['p-4']]}>
              <ActivityIndicator size="large" color="#231fda" />
            </View>
          ) : (
            <>
              <Image
                onLayout={onPhotoLayout}
                style={[{height: imageHeight, width: '100%'}]}
                source={{
                  uri: `${publicApiRoot}/dealer/photo/${dealer.id}`,
                }}
              />
              <View
                style={[
                  sy.contentView,
                  sy['items-center'],
                  sy['px-8'],
                  sy['py-14'],
                ]}>
                <Text
                  style={[
                    sy.xLarge,
                    sy['text-center'],
                    {fontSize: 24, lineHeight: 30},
                  ]}>
                  De offerte staat klaar
                </Text>
                <Text
                  style={[
                    sy.regular,
                    sy['text-center'],
                    {
                      fontSize: 18,
                      lineHeight: 22.5,
                      textAlign: 'center',
                      paddingTop: 7,
                      paddingBottom: 50,
                    },
                  ]}>
                  Maak je reservering definitief door de opdracht te bevestigen.
                </Text>
                <View>
                  {!loading && (
                    <DefaultButton
                      style={[
                        sy.transparentButton,
                        {
                          shadowOffset: {width: 0, height: 1.5},
                          shadowOpacity: 0.2,
                          shadowColor: '#000',
                          shadowRadius: 5,
                          elevation: 3,
                          width: 120,
                          paddingHorizontal: 0,
                          paddingTop: 10,
                          paddingBottom: 7,
                        },
                      ]}
                      onPress={() => {
                        navigation.navigate('Chat', {request_id});
                      }}>
                      <Text
                        style={[
                          sy.medium,
                          {
                            color: '#231fda',
                            textTransform: 'uppercase',
                            fontSize: 14,
                          },
                        ]}>
                        Beoordelen
                      </Text>
                    </DefaultButton>
                  )}
                </View>
              </View>
            </>
          )}
        </>
      </PublicContentView>
    </SafeAreaView>
  );
};

export default Intro;
